import { ChangeEvent } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { theme } from "../../../utils/theme";

const UPLOAD_INPUT_ID = "upload-cetificate";

type CertificateUploadProps = {
  previewUrl: string;
  hasFile: boolean;
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export function CertificateUpload({
  previewUrl,
  hasFile,
  onFileChange,
}: CertificateUploadProps) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: { xs: 12, sm: 16 },
          color: "red",
          margin: { sm: "10px 90px" },
        }}>
        For purchasing our products with tax-free, please kindly upload your
        Resale Certificate here.
      </Typography>
      <input
        accept="image/*"
        name="cetificate"
        style={{ display: "none" }}
        type="file"
        id={UPLOAD_INPUT_ID}
        onChange={onFileChange}
      />

      <Button
        sx={{
          display: "flex",
          margin: "auto",
          textTransform: "capitalize",
          borderRadius: 10,
          width: { xs: 220, sm: 250 },
          backgroundColor: "#e4e5e9",
          color: `${theme.palette.text.body}`,
          ":hover": { backgroundColor: "#e4e5e9" },
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        }}>
        <label htmlFor={UPLOAD_INPUT_ID} style={{ cursor: "pointer" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              margin: "auto",
            }}>
            <CloudUploadIcon
              sx={{ color: `${theme.palette.common.green}`, mr: "5px" }}
            />
            <Typography sx={{ marginBottom: 0, fontSize: { xs: 14, sm: 16 } }}>
              Upload Resale Certificate
            </Typography>
          </Box>
        </label>
      </Button>
      <Box sx={{ margin: "25px 0" }}>
        {hasFile && previewUrl && (
          <Box
            component="img"
            src={previewUrl}
            alt="Resale certificate preview"
            sx={{
              marginBottom: "25px",
              display: "flex",
              margin: "auto",
              alignItems: "center",
              width: "100%",
              maxHeight: "400px",
              objectFit: "fill",
              borderRadius: "10px",
            }}
          />
        )}
      </Box>
    </Box>
  );
}
